<template>
    <div class="course__show_tabs">
        <template v-if="filteredTabs.length > 1">
            <div class="course__show_tabs_top">
                <div class="columns is-vcentered">
                    <div class="column">
                        <div class="course__show_tabs_top_nav">
                            <ul>
                                <li
                                    v-for="(tab, index) in filteredTabs"
                                    :key="index"
                                >
                                    <component-button
                                        :name="'course-show-tabs-switch'"
                                        :theme="'nav'"
                                        :size="'medium'"
                                        :is-active="tab.name === activeTab"
                                        :secondary-theme="tab.name === activeTab ? 'primary' : ''"
                                        @click="switchTab(tab.name)"
                                    >{{ toCapitalize(fromKebabCaseToString(tab.name)) }}
                                    </component-button>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <div class="course__show_tabs_content">
            <transition-group name="fade" mode="out-in">
                <div
                    :key="tabs[0].name"
                    v-if="tabs[0].name === activeTab && tabs[0].visible()"
                    class="course__show_tabs_content_inner"
                >
                    <course-show-content></course-show-content>
                </div>
                <div
                    :key="tabs[1].name"
                    v-if="tabs[1].name === activeTab && tabs[1].visible()"
                    class="course__show_tabs_content_inner"
                >
                    <course-show-versions></course-show-versions>
                </div>
            </transition-group>
        </div>
    </div>
</template>

<script>
import CourseShowVersions from '@/components/ebs/courses/show/CourseShowVersions'
import CourseShowContent from '@/components/ebs/courses/show/CourseShowContent'
import { User } from '@/User'
import ComponentButton from '@/components/default/shared/ComponentButton'

export default {
  name: 'course-show-tabs',
  components: { ComponentButton, CourseShowContent, CourseShowVersions },
  data () {
    return {
      user: new User(),
      tabs: [
        {
          name: 'content',
          visible: () => true
        },
        {
          name: 'versions',
          visible: () => (
            this.routeIsCourseView
          )
        }
      ],
      activeTab: 'content'
    }
  },
  computed: {
    routeIsCourseView () {
      return this.$route.name === 'ebs-course-show'
    },
    filteredTabs: function () {
      return this.tabs.filter(tab => {
        return tab.visible()
      })
    }
  },
  methods: {
    switchTab: function (tab) {
      this.$router.push({ hash: `#${tab}`, query: this.$route.query })
      this.activeTab = tab
    }
  },
  mounted () {
    const routeHash = this.$route.hash.split('?')[0].replace('#', '')
    if (routeHash) {
      this.switchTab(routeHash)
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/courses/courseshowtabs";
</style>
